
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 900 600"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#377e3f","d":"M0 0h900v600H0z"}}),_c('path',{attrs:{"fill":"#fff","d":"M0 120h900v360H0z"}}),_c('path',{attrs:{"fill":"#b40a2d","d":"M0 180h900v240H0z"}}),_c('path',{attrs:{"d":"M450 191.459l70.534 217.082-184.661-134.164h228.254L379.466 408.541z","fill":"#ecc81d"}})])
          )
        }
      }
    